module.exports = __webpack_public_path__ + "static/media/import-database.8dcf7c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/import-database.png
// module id = 275
// module chunks = 0